module.exports = __webpack_public_path__ + "static/assets/d52a9f0f59cd75bb37db958947ddd83e.png";